export const debounce = (func, wait, immediate) => {
    let timeout = null

    return function () {
        const context = this
        const args = arguments

        const later = () => {
            timeout = null

            if (!immediate) {
                func.apply(context, args)
            }
        }

        const callNow = immediate && !timeout

        clearTimeout(timeout)

        timeout = setTimeout(later, wait)

        if (callNow) {
            func.apply(context, args)
        }
    }
}

//Scroll tracking
let distanceScrolled = -1
let distanceThreshold = [
    { threshold: 0, value: 'Baseline', sent: false },
    { threshold: 25, value: '25%', sent: false },
    { threshold: 50, value: '50%', sent: false },
    { threshold: 75, value: '75%', sent: false },
    { threshold: 90, value: '90%', sent: false },
    { threshold: 100, value: '100%', sent: false },
]

const scrollDepth = () => {
    const scrollTop = document.body.scrollTop || document.documentElement.scrollTop
    let progress = Math.round(
        (scrollTop / (document.body.scrollHeight - window.innerHeight)) * 100
    )

    if (isNaN(progress)) progress = 0;

    if (progress > distanceScrolled) {
        distanceScrolled = progress

        for (let i = 0; i < distanceThreshold.length; i++) {
            const status = distanceThreshold[i].sent
            const threshold = distanceThreshold[i].threshold
            const value = distanceThreshold[i].value

            if (!status && progress >= threshold) {
                if ("dataLayer" in window) {
                    window.dataLayer.push({
                        event: "gatsbyScroll",
                        gatsbyScrollDistance: value,
                    })
                    distanceThreshold[i].sent = true
                }
            }
        }
    }
}
const scrollListener = debounce(scrollDepth, 18);

const GTM = {
    init: () => {
        const interval = setInterval(() => {
            if ("dataLayer" in window && "google_tag_manager" in window) {
                window.dataLayer.push({ event: "gatsby-route-change" });
                clearInterval(interval);
            }
        }, 100);
        scrollDepth();
        document.addEventListener('scroll', scrollListener);
    },
    formStart: (formName) => {
        if ("dataLayer" in window) {
            window.dataLayer.push({ event: "formStart", formName });
        }
    },
    formSubmission: (formName) => {
        if ("dataLayer" in window) {
            window.dataLayer.push({ event: "formCompletion", formName });
        }
    },
    formInputChange: (formName, fieldName, fieldValue) => {
        if ("dataLayer" in window) {
            window.dataLayer.push({
                event: "inputChange",
                formName,
                fieldName,
                fieldValue,
            });
        }
    },
    formFieldCompletionFormSubmitted: (formName, fieldName, fieldValue) => {
        if ("dataLayer" in window) {
            window.dataLayer.push({
                event: "formFieldCompletionFormSubmitted",
                formName,
                fieldName,
                fieldValue,
            });
        }
    },
    formInputError: (fieldName, fieldError, formName) => {
        if ("dataLayer" in window) {
            window.dataLayer.push({
                event: "inputError",
                fieldName,
                fieldError,
                formName,
            });
        }
    },
    errorPage: async() => {
        if ("dataLayer" in window) {
            // await for Osano load success event
            await new Promise((resolve) => {
                let interval;
                const timeout = setTimeout(() => {
                    if (interval) clearInterval(interval);
                    resolve(); // Resolve anyway after timeout to prevent infinite waiting
                }, 3000);

                interval = setInterval(() => {
                    const loaded = window.dataLayer.find(item => item.event === "osano__cm--load-success");
                    if (loaded) {
                        clearInterval(interval);
                        clearTimeout(timeout);
                        resolve();
                    }
                }, 100);
            });
            
            window.dataLayer.push({
                event: "error_page_load",
            });
        }
    },
    reset: () => {
        distanceScrolled = -1;
        distanceThreshold.forEach((threshold) => (threshold.sent = false));
    },
}

export default GTM